import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isReadReceiptOptionDirty(state) {
    var savedOptions = state.userOptions;
    var readReceiptResponse = getFallbackValueIfNull(state.optionState.readReceiptResponse, savedOptions.ReadReceipt);
    return readReceiptResponse !== savedOptions.ReadReceipt;
});
//# sourceMappingURL=isReadReceiptOptionDirty.js.map